import { render, staticRenderFns } from "./GalleryMod.vue?vue&type=template&id=7644a93f"
import script from "./GalleryMod.vue?vue&type=script&lang=js"
export * from "./GalleryMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports